(() => {
class KekkaMobileHeader {
  constructor(header) {
    this.header = header;
    this.panel = header.querySelector('.custom-header-dropdown');
    this.menu = header.querySelector('.drawer-menu-view');
    this.search = header.querySelector('.drawer-search-view');
    this.menuButton = header.querySelector('.custom-header-toggle');
    this.searchButton = header.querySelector('.js-open-custom-search');
    this.input = header.querySelector('#Drawer-Search');
    this.results = header.querySelector('#drawer-search-results');
    this.events = new AbortController();
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const options = { signal: this.events.signal };
    this.hero = document.querySelector('.kekka-hero');
    const scheduleBackdrop = () => {
      if (this.backdropFrame) return;
      this.backdropFrame = requestAnimationFrame(() => {
        this.backdropFrame = null;
        this.updateBackdrop();
      });
    };
    document.addEventListener('scroll', scheduleBackdrop, { ...options, passive: true, capture: true });
    window.addEventListener('resize', scheduleBackdrop, options);
    this.heroObserver = new ResizeObserver(scheduleBackdrop);
    if (this.hero) this.heroObserver.observe(this.hero);
    this.updateBackdrop();
    this.menuButton.addEventListener('click', () => this.setState(this.state === 'menu' ? 'closed' : 'menu'), options);
    this.searchButton.addEventListener('click', () => this.setState(this.state === 'search' ? 'closed' : 'search'), options);
    document.addEventListener('click', (event) => {
      if (this.state !== 'closed' && !header.contains(event.target)) this.setState('closed', false);
    }, options);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.state !== 'closed') {
        event.preventDefault();
        this.setState('closed');
      }
    }, options);
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) this.setState('closed', false);
      else this.updateHeight();
    }, options);
    window.addEventListener('scroll', () => this.updateHeight(), { ...options, passive: true });
    header.querySelector('#cart-icon-bubble').addEventListener('click', () => this.setState('closed', false), options);
    this.input.addEventListener('input', () => {
      this.cancelSearch();
      this.results.hidden = true;
      this.results.replaceChildren();
      const query = this.input.value.trim();
      if (query.length >= 2) this.timer = setTimeout(() => this.findProducts(query), 250);
    }, options);
    this.setState('closed', false);
  }
  get state() { return this.header.dataset.mobileState; }
  updateHeight() {
    const bottom = this.header.querySelector('header').getBoundingClientRect().bottom;
    this.panel.style.setProperty('--mobile-panel-max-height', `${Math.max(0, window.innerHeight - bottom)}px`);
  }
  cancelSearch() {
    clearTimeout(this.timer);
    this.request?.abort();
  }
  updateBackdrop() {
    const toolbar = this.header.querySelector('header');
    const edge = Math.max(0, this.header.getBoundingClientRect().top) + toolbar.offsetHeight;
    const footerBounds = this.header.dataset.pageType === 'index'
      ? document.querySelector('.kekka-footer')?.getBoundingClientRect() : null;
    const isOverFooter = Boolean(footerBounds && footerBounds.top <= edge && footerBounds.bottom > edge);
    this.header.classList.toggle('is-over-footer', isOverFooter);
    const heroBounds = this.hero?.getBoundingClientRect();
    const progress = heroBounds?.height > 0 ? Math.min(1, Math.max(0, (edge - heroBounds.bottom) / 160)) : 0;
    this.header.style.setProperty('--header-backdrop-blur', `${(progress * 20).toFixed(2)}px`);
    this.header.style.setProperty('--header-backdrop-opacity', progress.toFixed(3));
  }
  setState(state, restoreFocus = true) {
    const previous = this.state;
    if (state === previous && state === 'closed') return;
    const previousHeight = this.panel.hidden ? 0 : this.panel.getBoundingClientRect().height;
    this.panelAnimation?.cancel();
    this.contentAnimations?.forEach(animation => animation.cancel());
    this.header.dataset.mobileState = state;
    this.panel.hidden = false;
    this.panel.inert = state === 'closed';
    if (state !== 'closed') {
      this.menu.hidden = state !== 'menu';
      this.search.hidden = state !== 'search';
    }
    this.menuButton.setAttribute('aria-expanded', String(state === 'menu'));
    this.menuButton.setAttribute('aria-label', state === 'menu' ? 'Close menu' : 'Open menu');
    this.searchButton.setAttribute('aria-expanded', String(state === 'search'));
    this.searchButton.setAttribute('aria-label', state === 'search' ? 'Close search' : 'Open search');
    this.cancelSearch();
    if (state !== 'closed') {
      this.header.closest('.section-header')?.classList.remove('shopify-section-header-hidden');
      this.updateHeight();
    }
    const finish = () => {
      if (this.state !== state) return;
      this.panel.hidden = state === 'closed';
      if (state === 'closed') {
        this.menu.hidden = true;
        this.search.hidden = true;
      }
    };
    if (this.reducedMotion.matches || window.innerWidth >= 990) finish();
    else {
      const targetHeight = this.panel.getBoundingClientRect().height;
      const frames = state === 'closed'
        ? [{ height: `${previousHeight}px`, clipPath: 'inset(0 0 0% 0)' }, { height: `${previousHeight}px`, clipPath: 'inset(0 0 100% 0)' }]
        : [{ height: `${previousHeight || targetHeight}px`, clipPath: previous === 'closed' ? 'inset(0 0 100% 0)' : 'inset(0)' }, { height: `${targetHeight}px`, clipPath: 'inset(0)' }];
      this.panelAnimation = this.panel.animate(frames, { duration: state === 'closed' ? 280 : 450, easing: 'cubic-bezier(.22, 1, .36, 1)' });
      this.panelAnimation.onfinish = finish;
      if (state !== 'closed') {
        const content = state === 'menu' ? [...this.menu.querySelectorAll('.custom-header-card')] : [this.search];
        this.contentAnimations = content.map((element, index) => element.animate(
          [{ opacity: 0, transform: 'translateY(24px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 420, delay: state === 'menu' ? 140 + index * 85 : 0, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' }
        ));
      }
    }
    if (state === 'search') this.input.focus({ preventScroll: true });
    else if (state === 'closed' && restoreFocus) {
      (previous === 'search' ? this.searchButton : this.menuButton).focus({ preventScroll: true });
    } else if (state === 'menu' && previous === 'search') this.menuButton.focus({ preventScroll: true });
  }
  async findProducts(query) {
    this.request = new AbortController();
    const request = this.request;
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(`${root}search/suggest.json`, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '6');
    try {
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw new Error('Search unavailable');
      const data = await response.json();
      if (request.signal.aborted || this.state !== 'search' || this.input.value.trim() !== query) return;
      this.results.replaceChildren();
      const products = data.resources?.results?.products || [];
      for (const product of products) {
        const link = document.createElement('a');
        link.className = 'search-item';
        link.href = product.url;
        const imageURL = product.featured_image?.url || product.image;
        if (imageURL) {
          const image = document.createElement('img');
          image.src = imageURL;
          image.alt = '';
          image.width = image.height = 48;
          link.append(image);
        }
        const title = document.createElement('span');
        title.className = 'search-item-title';
        title.textContent = product.title;
        const details = document.createElement('span');
        details.className = 'search-item-details';
        details.append(title);
        if (product.price != null) {
          const price = document.createElement('span');
          price.className = 'search-item-price';
          price.textContent = product.price;
          details.append(price);
        }
        link.append(details);
        this.results.append(link);
      }
      if (!products.length) this.showMessage('No products found. Try another search.');
      this.results.hidden = false;
    } catch (error) {
      if (error.name === 'AbortError') return;
      if (this.state === 'search' && this.input.value.trim() === query) {
        this.showMessage('Suggestions are unavailable. Press Enter to search.');
      }
    }
  }
  showMessage(text) {
    const message = document.createElement('p');
    message.textContent = text;
    this.results.replaceChildren(message);
    this.results.hidden = false;
  }
  destroy() {
    this.cancelSearch();
    this.panelAnimation?.cancel();
    this.contentAnimations?.forEach(animation => animation.cancel());
    this.heroObserver.disconnect();
    cancelAnimationFrame(this.backdropFrame);
    this.events.abort();
  }
}
  const initialize = (root) => root.querySelectorAll('[data-mobile-header]').forEach((header) => {
    if (!header.mobileHeaderController) header.mobileHeaderController = new KekkaMobileHeader(header);
  });
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mobile-header]').forEach((header) => header.mobileHeaderController?.destroy());
  });
})();
